import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpecialityCategory } from '../../../core/models/find-care/speciality-category';
import { Speciality, SpecialitySubCategory } from '../../../core/models/find-care/speciality-sub-category';
import { Specialization } from '../../../core/models/find-care/specialization';
import { CommonService } from '../../../core/services/v2/common.service';
import { UserService } from '../../../core/services/v2/user.service';
import { UtilsService } from '../../../core/services/v2/utils.service';
import { WindowLoaderService } from '../window-loader/window-loader.service';
import * as _ from 'lodash';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { MapLocation, MapZipLocation } from '../../../core/models/google-map-marker';
import { PatientService } from '../../../core/services/v2/patient.service';
import { Patient } from '../../../core/models/patient/patient';
import { AppyUser } from '../../../core/model/v2/AppyUser';
import { PatientInsuranceDetail } from '../../../core/models/patient/patientInsuranceDetail';

@Component({
  selector: 'app-find-care',
  templateUrl: './find-care.component.html',
  styleUrls: ['./find-care.component.scss']
})
export class FindCareComponent implements OnInit {
  categories: SpecialityCategory[];
  categoriesFiltered: SpecialityCategory[];
  specializations: Speciality[];
  specializationsFiltered: Speciality[];
  selectedCategoryId: number;
  selectedCategory: SpecialityCategory;
  specialities: Speciality[];
  subCategoriesFiltered: Speciality[];
  subCategoryAToZ: boolean = true;
  specializationAToZ: boolean = true;
  locationResult: Observable<any[]>;
  searchZipCode: FormControl = new FormControl('');
  useLiveLocation: FormControl = new FormControl(false);
  zipcodeLocation: MapZipLocation;
  patientDetail: Patient;
  user: AppyUser;

  constructor(
    private userService: UserService,
    private commonService: CommonService,
    private patientService: PatientService,
    private route: ActivatedRoute,
    private router: Router,
    private utils: UtilsService,
    private loaderService: WindowLoaderService) { }

  ngOnInit() {
    this.selectedCategoryId = 0;
    this.selectedCategory = null;
    this.userService.getUserDetails().subscribe((user) => {
      this.user = user;
      this.bindParamsAndForm();
    });
    //this.bindParamsAndForm();
    this.getFindCareCategories();
    this.locationResult = this.searchZipCode.valueChanges.pipe(
      startWith(''),
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((val) => {
        if (!val || val.length < 3) {
          return new Observable<any[]>();
        }
        return this.getLocationByZipCode(val || '');
      })
    );
  }

  bindParamsAndForm() {
    this.selectedCategoryId = this.route.snapshot.params['categoryId'];
    if (this.selectedCategoryId && this.selectedCategoryId > 0) {
      this.getFindCareSpeciality(this.selectedCategoryId);
    }
    let queryParams = this.route.snapshot.queryParams;
    if (queryParams && queryParams.lat && queryParams.zipCode) {
      this.setZipCode(queryParams.zipCode);
      //this.zipcodeLocation = { lat: queryParams.lat, lng: queryParams.lng, zipCode: queryParams.zipCode };
      //this.searchZipCode.setValue(queryParams.zipCode);
    }
    else {
      this.getPatientDetailsByUserId();
    }
  }

  getPatientDetailsByUserId() {
    this.loaderService.blockWithLoader(this.patientService.getCurrentPatientDetails()).subscribe(
      (details) => {
        this.patientDetail = null;
        this.patientDetail = details;
        let addresses = this.patientDetail.addresses ? this.patientDetail.addresses.filter(x => x.type == 'HOME') : null;
        if (addresses && addresses.length > 0) {
          const homeAddress = addresses[0];
          this.setZipCode(homeAddress.zipCode);
        }
      },
      (error) => { console.error(error); }
    );
  }

  setZipCode(zipcode: string) {
    this.getLocationByZipCode(zipcode).subscribe((zipCodes) => {
      const data = zipCodes.filter(x => x.zipCode == zipcode);
      if (data && data.length > 0) {
        this.zipcodeLocation = { lat: data[0].latitude, lng: data[0].longitude, zipCode: data[0].zipCode, useLiveLocation: false };
        this.searchZipCode.setValue(`${data[0].city}, ${data[0].stateName}, ${data[0].zipCode}`);
      }
    });
  }

  _filterCategory(event) {
    const filterValue = event.target.value.toLowerCase();
    this.categoriesFiltered = this.categories.filter(option => option.category.toLowerCase().includes(filterValue));
  }

  getFindCareCategories() {
    this.loaderService.blockWithLoader(this.commonService.GetSpecialtyCategories(this.selectedCategoryId)).subscribe(
      (details) => {
        if (details.resultStatus.isSuccess) {
          this.categories = details.specialtyCategoriesList;
          this.categoriesFiltered = details.specialtyCategoriesList;
          if (this.selectedCategoryId && this.selectedCategoryId > 0) {
            this.selectedCategory = this.categories.filter(x => x.id == this.selectedCategoryId)[0];
            //this.getFindCareSpeciality(this.selectedCategory.id);
          }
        }
        else {
          this.utils.showMessageSnackBar(details.resultStatus.message, true);
        }
      },
      (error) => { console.error(error); this.loaderService.hide(); }
    );
  }

  getFindCareSpeciality(categoryId: number) {
    this.loaderService.blockWithLoader(this.commonService.getSpecialty(categoryId)).subscribe(
      (details) => {
        if (details.response.isSuccess) {
          this.specialities = details.specialties;
          const specialities = details.specialties.map(x => ({ ...x, isChecked: false }));
          this.subCategoriesFiltered = specialities;
          //this.subCategoriesFiltered = details.specialties.sort((a, b) => a.subCategory > b.subCategory ? 1 : -1);;
        }
        else {
          this.utils.showMessageSnackBar(details.resultStatus.message, true);
        }
      },
      (error) => { console.error(error); this.loaderService.hide(); }
    );
  }

  getLocationByZipCode(searchTerm: string) {
    return this.loaderService.blockWithLoader(this.commonService.GetLocationByZipcode(searchTerm)).pipe(
      tap(),
      map((response) => {
        return response.zipLocationList;
      })
    );
  }

  loadSpecialization(specialityId: number) {
    this.loaderService.blockWithLoader(this.commonService.GetSpecialization(specialityId)).subscribe(
      (details) => {
        if (details.response.isSuccess) {
          this.specializations = details.specialties;
          this.specializations = this.specializations.map(x => ({ ...x, isChecked: false }));
          this.specializationsFiltered = this.specializations.sort((a, b) => a.name > b.name ? 1 : -1);
        }
        else {
          this.utils.showMessageSnackBar(details.resultStatus.message, true);
        }
      },
      (error) => { console.error(error); this.loaderService.hide(); }
    );
  }

  gotoSubCategory(category: any) {
    if (this.useLiveLocation.value == true) {
      this.zipcodeLocation = null;
    }
    this.router.navigate([category.id], {
      relativeTo: this.route,
      queryParams: this.zipcodeLocation
    });
  }

  selectSubCategory(subCategoryId: number, index: number) {
    this.subCategoriesFiltered = this.subCategoriesFiltered.map(x => ({ ...x, isChecked: false }));
    this.subCategoriesFiltered[index].isChecked = true;
    this.loadSpecialization(subCategoryId);
  }

  selectSpecialization(specializationId: number, index: number) {
    this.specializationsFiltered = this.specializationsFiltered.map(x => ({ ...x, isChecked: false }));
    this.specializationsFiltered[index].isChecked = true;
    this.getPractitionerAndHealthSystem();
  }

  _filterSubCategory(event) {
    const filterValue = event.target.value.toLowerCase();
    this.subCategoriesFiltered = this.specialities.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  _filterSpecialization(event) {
    const filterValue = event.target.value.toLowerCase();
    this.specializationsFiltered = this.specializations.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  sortSubCategory() {
    if (!this.subCategoryAToZ) {
      this.subCategoryAToZ = !this.subCategoryAToZ;
      this.subCategoriesFiltered = this.subCategoriesFiltered.sort((a, b) => a.name > b.name ? 1 : -1); //_.sortBy(this.subCategoriesFiltered, 'subCategory');
    }
    else {
      this.subCategoryAToZ = !this.subCategoryAToZ;
      this.subCategoriesFiltered = this.subCategoriesFiltered.sort((a, b) => a.name < b.name ? 1 : -1);
    }
  }

  sortSpecialization() {
    if (!this.specializationAToZ) {
      this.specializationsFiltered = _.sortBy(this.specializationsFiltered, 'category');
    }
    else {
      this.specializationsFiltered = this.specializationsFiltered.sort((a, b) => a.name < b.name ? 1 : -1);
    }
    this.specializationAToZ = !this.specializationAToZ;
  }

  getPractitionerAndHealthSystem() {
    let insuranceDetails;
    let subCategory;
    let specializationId = 0;
    const selectedSubCategory = this.subCategoriesFiltered.filter(x => x.isChecked == true);
    if (selectedSubCategory && selectedSubCategory.length > 0) {
      subCategory = selectedSubCategory[0];
    }
    else {
      this.utils.showMessageSnackBar("Please select SubCataegory first.", true);
      return;
    }

    const selectedSpecialization = this.specializationsFiltered.filter(x => x.isChecked == true);
    if (selectedSpecialization && selectedSpecialization.length > 0) {
      specializationId = selectedSpecialization[0].id;
    }

    if (this.useLiveLocation.value == true || this.user.role != 'Patient' ) {
      this.zipcodeLocation = null;
    }
    if (this.user.role == 'Patient') {
      this.loaderService.blockWithLoader(this.patientService.getCurrentPatientDetails()).subscribe(
        (details) => {
          this.patientDetail = null;
          this.patientDetail = details;
          insuranceDetails = this.patientDetail.patientInsurances.find(x => x.insuranceType == "Primary" && x.insurancePlanPayerId != null);
          this.RoutToFindCare(subCategory, specializationId, selectedSpecialization, insuranceDetails);
        },
        (error) => { console.error(error); }
      );
    }
    else
    {
      this.useLiveLocation.setValue(true);
      this.RoutToFindCare(subCategory, specializationId, selectedSpecialization, insuranceDetails);
    }
  }


  private RoutToFindCare(subCategory: any, specializationId: number, selectedSpecialization: Speciality[], insuranceDetails: PatientInsuranceDetail) {
    this.router.navigate(['../../', 'team', 'findcare'], {
      relativeTo: this.route,
      queryParams: {
        catId: this.selectedCategoryId,
        subCatId: subCategory.id,
        specId: specializationId,
        subSpeciality: selectedSpecialization[0].name,
        lat: this.route.snapshot.queryParams['lat'] ? this.route.snapshot.queryParams['lat'] : 0,
        lng: this.route.snapshot.queryParams['lng'] ? this.route.snapshot.queryParams['lng'] : 0,
        zipCode: this.zipcodeLocation ? this.zipcodeLocation.zipCode : 0,
        planid: insuranceDetails ? insuranceDetails.insurancePlanPayerId : "",
        planName: insuranceDetails ? insuranceDetails.insurancePlanName : ""
      }
    });
  }

  getSelectedLatLong(option: any) {
    this.zipcodeLocation = { lat: option.latitude, lng: option.longitude, zipCode: option.zipCode, useLiveLocation: false };
    this.searchZipCode.setValue(`${option.city}, ${option.stateName}, ${option.zipCode}`);
  }

  gotoFindCare() {
    this.router.navigate(['../'], {
      relativeTo: this.route,
      queryParams: this.zipcodeLocation
    });
  }

  liveLocationCheckChange(event: any) {
    if (event.checked) {
      this.searchZipCode.disable();
      //this.zipcodeLocation.useLiveLocation = true;
    }
    else {
      this.searchZipCode.enable();
      //this.zipcodeLocation.useLiveLocation = false;
    }
  }

}
